export default __webpack_public_path__ + "static/ticketsvg-12efa4cf26e521db92e0697fd27a3c68.svg";